import type { TakeActionDropdownData } from 'components/TakeActionDropdown/types/TakeActionDropdownData';
import { I18nLocale } from 'i18n/types/I18nLocale';
import { searchGetVolopsRoutePath } from 'modules/search/routing/helpers/searchGetVolopsRoutePath';

export const takeActionDropdownDataEn: TakeActionDropdownData = {
  search: {
    title: 'Volunteers',
    items: [
      {
        type: 'volop',
        title: 'Search Volunteer Opportunities',
        href: searchGetVolopsRoutePath({ locale: I18nLocale.EN }),
      },
      {
        type: 'volunteer-resources',
        title: 'Volunteer Resources',
        href: '/en/volunteering-resources?pq=',
      },
    ],
  },
  resources: {
    title: 'Business Solutions',
    items: [
      {
        type: 'api-search-modules',
        title: 'API & Search Module',
        description: 'Explore our solutions for your company or CSR platform.',
        href: '/volunteersolutions',
      },
      {
        type: 'our-partners',
        title: 'Our Partners',
        description:
          'Enhance your volunteer engagement strategy through our trusted network.',
        href: '/csr-services',
      },
    ],
  },
};
